import './style.css';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import {
  Tab,
  Tabs,
} from '@thermon-platforms/thermon-ui-core';
import Server from './components/server';
import Network from './components/network';


function SystemHealth() {
  return (
    <div className="view system-health">
      <header>
        <h2><Trans>System Health</Trans></h2>
      </header>
      <section>
        <Tabs useNav={true}>
          <Tab name={t`Server`}>
            <Server />
          </Tab>
          <Tab name={t`Network`}>
            <Network />
          </Tab>
        </Tabs>
      </section>
    </div>
  );
}

export default SystemHealth;
